<template>
	<v-card class="mx-auto elevation-12" style="max-width: 500px">
		<v-card-title class="text-center headline font-weight-black">
			<v-spacer></v-spacer>
			Confirm Password Change
			<v-spacer></v-spacer>
		</v-card-title>
		<v-card-text>
			<v-form v-model="validForm">
				<v-row class="justify-center text-center">
					<v-col cols="12">
						<v-text-field v-model="code" label="Enter Code" name="code" type="text" :rules="[requiredRule]" outlined />
					</v-col>
					<v-col cols="12">
						<v-text-field v-model="email" label="Email" name="email" type="text" :rules="emailRules" outlined />
					</v-col>
					<v-col cols="12">
						<v-text-field
							v-model="new_password"
							label="Create New Password"
							name="new_password"
							type="password"
							outlined
							:loading="loadingConfirmRequest"
							:rules="passwordRules"
						/>
					</v-col>
					<v-col cols="12">
						<v-text-field
							v-model="confirm_new_password"
							label="Confirm New Password"
							name="confirm_new_password"
							type="password"
							outlined
							:loading="loadingConfirmRequest"
							:rules="[passwordConfirmationRule]"
						/>
					</v-col>
				</v-row>
			</v-form>
		</v-card-text>
		<v-card-actions>
			<v-row class="justify-center text-center" dense>
				<v-col cols="12">
					<p v-if="this.errMsg" id="err-message" class="text-center red--text">
						{{ this.errMsg }}
					</p>
				</v-col>
				<v-col cols="12">
					<v-btn
						class="mb-2 mr-3 py-2 px-5 text-none"
						depressed
						:disabled="loadingSendRequest"
						large
						rounded
						:loading="loadingSendRequest"
						color="secondary"
						to="/forgot-password"
						>Didn't Recieve Code?</v-btn
					>
					<v-btn
						class="mb-2 py-2 px-5 text-none"
						depressed
						large
						rounded
						color="primary"
						:disabled="!validForm || loadingSendRequest"
						:loading="loadingConfirmRequest"
						@click="confirmResetPassword"
						>Confirm password reset</v-btn
					>
				</v-col>
			</v-row>
		</v-card-actions>

		<!-- General Error Snackbar -->
		<v-snackbar v-model="errorSnackbar" top vertical color="white" :timeout="6000">
			<p class="text-center black--text mx-2">{{ errMsg }}</p>
			<v-btn icon @click="errorSnackbar = false">
				<v-icon>mdi-close</v-icon>
			</v-btn>
		</v-snackbar>

		<!-- Code Sent Snackbar -->
		<v-snackbar v-model="codeSentSnackbar" top vertical color="white" :timeout="3000">
			<p class="text-center black--text mx-2">Confirmation code sent</p>
			<v-btn icon @click="codeSentSnackbar = false">
				<v-icon>mdi-close</v-icon>
			</v-btn>
		</v-snackbar>
	</v-card>
</template>

<script>
import { Auth } from 'aws-amplify';

export default {
	name: 'UserResetPassword',
	data: () => ({
		loadingSendRequest: false,
		loadingConfirmRequest: false,
		errorSnackbar: false,
		codeSentSnackbar: false,
		validForm: false,
		email: '',
		code: '',
		new_password: '',
		confirm_new_password: '',
		errMsg: '',
		requiredRule: v => !!v || 'This field is required',
		emailRules: [v => !!v || 'This field is required', v => /@/.test(v || '') || 'Please enter a valid email'],
		passwordRules: [
			v => !!v || 'Password is required',
			v => (v && v.length >= 5) || 'Password must have 5+ characters',
			v => /(?=.*[A-Z])/.test(v) || 'Must have one uppercase character',
			v => /(?=.*\d)/.test(v) || 'Must have one number',
		],
	}),
	computed: {
		canGetCode() {
			return this.email && /@/.test(this.email);
		},

		passwordConfirmationRule() {
			return this.new_password === this.confirm_new_password || 'Password must match';
		},
	},
	mounted() {
		const username = this.$route.query && this.$route.query.username;
		if (username) this.email = username;
	},
	methods: {
		async confirmResetPassword() {
			this.errMsg = '';
			this.loadingConfirmRequest = true;
			try {
				await Auth.forgotPasswordSubmit(this.email.toLowerCase().trim(), this.code.trim(), this.new_password.trim());

				this.$router.push('/');
			} catch (error) {
				this.errMsg = error.message;
				this.errorSnackbar = true;
			} finally {
				this.loadingConfirmRequest = false;
			}
		},
		async sendCode() {
			this.loadingSendRequest = true;
			try {
				await Auth.forgotPassword(this.email.toLowerCase());
				this.codeSentSnackbar = true;
			} catch (error) {
				this.errMsg = error.message;
				this.errorSnackbar = true;
			} finally {
				this.loadingSendRequest = false;
			}
		},
	},
};
</script>
